
import { Component, Emit, Prop, Vue } from "nuxt-property-decorator";
import EsyCard from "~/components/atoms/sectioning/EsyCard.vue";
import EsyCardContent from "~/components/atoms/sectioning/EsyCardContent.vue";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import SummedRating from "~/components/molecules/display/ratings/SummedRating.vue";
import PartnerRating from "~/components/organisms/display/PartnerRating.vue";

type ComponentProps = {
  logoImage: { url?: string; name: string };
  profileImage?: { url: string; name: string };
  rating: {
    overall: { count: number; average: number };
    lastYear: { count: number; average: number };
  };
  isRalCertified: boolean;
  isOffline: boolean;
  ratingButtonLabel?: string;
  companyInfo?: { name: string; link: string };
};

@Component({
  components: {
    EsyCard,
    EsyCardContent,
    PartnerRating,
    SummedRating,
    RouterLink,
  },
})
export default class ProfileIntroCard extends Vue {
  @Prop() props: ComponentProps;

  @Emit()
  rateDealer() {
    return true;
  }
}
